import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { insertContract, updateContract } from '../../../api/webServices';
import Input from '../../UI/Input';
import ReactToPrint from 'react-to-print';
import { replaceQuotes, separador } from '../../../utils/various';

const inputsDef = [
    'servicioProveedor',
    'servicioDomicilio',
    'servicioCd',
    'servicioTelefono',
    'clausulaFallecido',
    'clausulaRecoleccion',
    'clausulaReligion',
    'clausulaHoraReligion',
    'clausulaNovenario',
    'clausulaAtaud',
    'clausulaParticipan',
    'clausulaInhumacion',
    'clausulaInhumacionDesc',
    'clausulaCremacion',
    'clausulaEsquelas',
    'clausulaSpotsRadio',
    'clausulaSpotsRedesSociales',
    'clausulaVelada',
    'clausculaCremacion',
    'clausulaOficios',
    'prestacionBasico',
    'prestacionEspecial',
    'prestacionAtaud',
    'prestacionAtaudPrecio',
    'prestacionEmbalsamada',
    'prestacionEmbalsamadaPrecio',
    'prestacionNocheAdicional',
    'prestacionNocheAdicionalPrecio',
    'prestacionCremacion',
    'prestacionCremacionPrecio',
    'prestacionUrna',
    'prestacionUrnaPrecio',
    'prestacionRecinto',
    'prestacionRecintoPrecio',
    'prestacionOtros',
    'prestacionOtrosPrecio',
    'prestacionPrecioTotal',
    'segundaMunicipal',
    'segundaTraslado',
    'segundaExhumacion',
    'segundaOtros',
    'terceraPesos',
    'terceraPesosLetra',
    'pagareVencimientoDia',
    'pagareVencimientoMes',
    'pagareVencimientoAnio',
    'pagareCantidad',
    'pagareSatisfaccion',
    'pagareInteres',
    'pagareNombre',
    'pagareDomicilio',
    'pagareCiudad',
    'pagareTelefono',
    'pagareAcepto',
    'pagareCantidad2',
    'cuartaPago',
    'cuartaAnticipo',
    'cuartaFecha',
    'cuartaSaldo',
    'quintaInteres',
    'finFecha',
    'finAnio',
    'avalNombre1',
    'avalDomicilio1',
    'avalTelefono1',
    'avalCiudad1',
    'avalNombre2',
    'avalDomicilio2',
    'avalTelefono2',
    'avalCiudad2',
    'testigo1',
    'observaciones1',
    'observaciones2',
    'observaciones3',
]

const emptyInputs = {};
//assign inputsObj with keys from inputsDef
inputsDef.forEach((input) => {
    emptyInputs[input] = '';
});

const Contract = () => {

    const { contractMode, actualContract } = useSelector(state => state.contracts);
    const [inputs, setInputs] = useState(contractMode === 'update' || contractMode === 'view' ? JSON.parse(actualContract?.data) : emptyInputs);
    const navigate = useNavigate();
    const divRef = useRef();

    const createInput = (label, name, width, className) => {
        let newWidth = width || 100;
        return (
            <Input name={name} onChange={change} disabled={contractMode === 'view'} value={inputs[name]} width={newWidth} className="h-5 inputForm" parentClassName={`inline-block ${className}`} labelTop={label} />
        )
    }
    const change = (e) => {
        let id = e.target.id;
        setInputs({ ...inputs, [id]: e.target.value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let parsedData = replaceQuotes(inputs)
        if (contractMode === 'update') {
            updateContract({ id: actualContract.id, data: JSON.stringify(parsedData) }).then(res => {
                navigate('/contracts');
            }).catch(err => {
                console.log(err);
            })
        }
        if (contractMode === 'new') {
            insertContract({ data: JSON.stringify(parsedData) }).then(res => {
                navigate('/contracts');
            }).catch(err => {
                console.log(err);
            })
        }
        if (contractMode === 'view') {
            navigate('/contracts');
        }

    }


    const getTitle = () => {
        switch (contractMode) {
            case 'update':
                return 'Editar contrato';
            case 'view':
                return 'Contrato';
            default:
                return 'Crear contrato';
        }
    }

    const getDescriptionAccept = () => {
        switch (contractMode) {
            case 'update':
                return 'Aceptar';
            case 'view':
                return 'Volver';
            default:
                return 'Aceptar';
        }
    }

    return (
        <div className="w-full h-screen">
            <h1 className="pt-5 pb-5 text-2xl text-center requestFormTitle">{getTitle()}</h1>
            <div ref={divRef} className="max-w-[1000px] mx-auto requestForm px-24 bg-white p-12 rounded-xl text-md font-sans text-justify">
                <p className="w-full font-bold text-center text-[16px]">SERVICIO FUNERAL DE USO INMEDIATO</p>
                <br></br>
                Contrato que garantiza la prestación de Servicios Funerarios que celebran por una parte Ramon Aguilar Ureña con domicilio en calle Leandro Valle No.25 de Ciudad Guzmán Jalisco. A quien por efecto de este contrato se le denominara EL PROVEEDOR.
                {createInput('', 'servicioProveedor', 600)}
                <p>&nbsp;&nbsp;&nbsp;</p>
                <br></br>
                <p>Domicilio</p>
                {createInput('', 'servicioDomicilio', 550)}
                <br></br>
                <p>Cd.</p>
                {createInput('', 'servicioCd', 450)}
                <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p>Teléfono</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                {createInput('', 'servicioTelefono', 200)}
                <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                a quien en lo sucesivo se le denomina EL CONSUMIDOR ambas partes están conformes en sujetarse a este contrato de acuerdo a las siguientes declaraciones y clausulas.
                <br></br>
                <p className="w-full font-bold text-center text-[16px]">DECLARACIONES</p>
                <br></br>
                <div>
                    <p>
                        I.- Declara El consumidor tener capacidad legal y económica para contratar y obligarse, dice conocer los servicios que presta EL PROVEEDOR, así como el funcionamiento de los mismos y que es su voluntad contratar un servicio funeral de Uso Inmediato con el PROVEEDOR, por lo que todos los datos de el se asentaran en el presente contrato, los proporciona bajo protesta de decir verdad.
                    </p>
                    <br></br>
                    <p>
                        II.-Declara EL PROVEEDOR ser una persona Física con RFC . AUUR740919UY9 con domicilio fiscal en Leandro Valle No.25 de Ciudad Guzmán Municipio de Zapotlán el Grande Jalisco tel. 3414130510 y que además cuenta con licencia sanitaria de la secretaria de Salud, Licencia Municipal y elementos legales para la prestación de servicios funerarios, dispone de laboratorio de embalsamamiento autorizado, salas, y equipos de velación, vehículos exclusivos para su uso funeral u crematorio particular de su propiedad.
                    </p>
                </div>
                <br></br>
                <p className="w-full font-bold text-center text-[16px]">CLAUSULAS</p>
                <br></br>
                <div>
                    <p>
                        <strong>PRIMERA.-</strong>  EL CONSUMIDOR, Solicita a el PROVEEDOR y este acepta y se obliga a prestar un servicio funeral de uso inmediato para el USUARIO, cuya persona fallecida es:
                    </p>
                </div>
                <div className="text-justify">
                    {createInput('', 'clausulaFallecido', 500)}
                    &nbsp;Para realizar su recolección en
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('', 'clausulaRecoleccion', 450)}
                    &nbsp;la cual será velada en
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('', 'clausulaVelada', 450)}
                    &nbsp;&nbsp;celebrando los oficios ceremoniales en
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('', 'clausulaOficios', 400)}
                    &nbsp;&nbsp;a las
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('', 'clausulaHora', 100)}
                    Hrs., &nbsp;&nbsp;
                    con novenario
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('', 'clausulaNovenario', 450)}.
                    <br></br>
                    Le participan:
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('', 'clausulaParticipan', 500)}
                    <br></br>
                    Llevándose a inhumación ({createInput('', 'clausulaInhumacion', 30)}<p>&nbsp;</p>)
                    <p>&nbsp;</p>
                    {createInput('', 'clausulaInhumacionDesc', 400)}
                    <br></br>
                    Cremación ({createInput('', 'clausculaCremacion', 30)}<p>&nbsp;</p>)
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    Esquelas ({createInput('', 'clausulaEsquelas', 30)}<p>&nbsp;</p>)
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    Spots Radio ({createInput('', 'clausulaSpotsRadio', 30)}<p>&nbsp;</p>)
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    Spots Redes Sociales ({createInput('', 'clausulaSpotsRedesSociales', 30)}<p>&nbsp;</p>)
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    <br></br>
                    <br></br>
                    Los servicios que adquiere EL CONSUMIDOR se marcan con la relación del paquete que a continuación se detalla.
                </div>
                <div>
                    {createInput('Ataúd Modelo.-', 'clausulaAtaud', 600)}
                </div>
                <div className="relative items-center justify-center w-full py-6 text-center">
                    <br></br>
                    <p className="text-center">Prestaciones de Servicio Funeral</p>
                    <br></br>
                    <p>&nbsp;&nbsp;&nbsp;</p>
                    <p className="text-sm">Complementario Paquete Básico</p>
                    {createInput('', 'prestacionBasico', 50)}
                    <p className="text-sm">Paquete Especial</p>
                    {createInput('', 'prestacionEspecial', 50)}
                </div>
                <br></br>
                <p className="w-full text-center text-[16px]">SERVICIOS</p>
                <br></br>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <p className="absolute left-[100px] text-sm">Ataúd Modelo.-</p>
                    {createInput('', 'prestacionAtaud', 200, 'absolute left-[210px]')}
                    <p className="absolute text-sm right-[285px]">$ </p>
                    {createInput('', 'prestacionAtaudPrecio', 100, 'absolute right-44')}
                </div>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <p className="absolute left-[100px] text-sm">Embalsamada</p>
                    {createInput('', 'prestacionEmbalsamada', 200, 'absolute left-[210px]')}
                    <p className="absolute text-sm right-[285px]">$ </p>
                    {createInput('', 'prestacionEmbalsamadaPrecio', 100, 'absolute right-44')}
                </div>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <p className="absolute left-[100px] text-sm">Noche adicional</p>
                    {createInput('', 'prestacionNocheAdicional', 200, 'absolute left-[210px]')}
                    <p className="absolute text-sm right-[285px]">$ </p>
                    {createInput('', 'prestacionNocheAdicionalPrecio', 100, 'absolute right-44')}
                </div>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <p className="absolute left-[100px] text-sm">Cremación</p>
                    {createInput('', 'prestacionCremacion', 200, 'absolute left-[210px]')}
                    <p className="absolute text-sm right-[285px]">$ </p>
                    {createInput('', 'prestacionCremacionPrecio', 100, 'absolute right-44')}
                </div>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <p className="absolute left-[100px] text-sm">Urna</p>
                    {createInput('', 'prestacionUrna', 200, 'absolute left-[210px]')}
                    <p className="absolute text-sm right-[285px]">$ </p>
                    {createInput('', 'prestacionUrnaPrecio', 100, 'absolute right-44')}
                </div>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <p className="absolute left-[100px] text-sm">Recinto Américas</p>
                    {createInput('', 'prestacionRecinto', 200, 'absolute left-[210px]')}
                    <p className="absolute text-sm right-[285px]">$ </p>
                    {createInput('', 'prestacionRecintoPrecio', 100, 'absolute right-44')}
                </div>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <div>
                        <p className="absolute left-[100px] text-sm">Otros</p>
                        {createInput('', 'prestacionOtros', 200, 'absolute left-[210px]')}
                    </div>
                    <p className="absolute text-sm right-[285px]">$ </p>
                    {createInput('', 'prestacionOtrosPrecio', 100, 'absolute right-44')}
                </div>
                <div className="relative flex flex-row items-center justify-center w-full">
                    <div>
                    </div>
                    <p className="absolute text-sm right-[285px]">Total $ </p>
                    {createInput('', 'prestacionPrecioTotal', 100, 'absolute right-44')}
                </div>
                {separador(42).map((p) => (p))}
                <div className="p-2 border border-black">
                    <p className="text-center">OBSERVACIONES</p>
                    <br></br>
                    {createInput('', 'observaciones1', 550)}
                    <br></br>
                    {createInput('', 'observaciones2', 550)}
                </div>
                <p className="relative w-full font-bold text-center text-[16px] mt-[40px] pb-12">SUB TOTAL DEL SERVICIO CONTRATADO IVA INCLUIDO</p>
                <br></br>
                <br></br>
                <br></br>
                <p>
                    <strong>SEGUNDA.-</strong> EL CONSUMIDOR Sera responsable y entregara el certificado de defunción requisitado, podrá también entregar el importe para tramites oficiales y religiosos por cuyo caso autoriza a EL PROVEEDOR para la gestión correspondiente, Además reconoce y acepta que no serán causas imputables a EL PROVEEDOR la cancelación o incumplimiento de los servicios señalados en la presente clausula, ya que estarán sujetos a las decisiones de el CONSUMIDOR, así mismo facturación y recibos se entregaran por separado del paquete contratado-
                </p>
                <br></br>
                <div>
                    {createInput('Imp. Municipal', 'segundaMunicipal', 80)}
                    <p>&nbsp;</p>
                    {createInput('Traslado', 'segundaTraslado', 80)}
                    <p>&nbsp;</p>
                    {createInput('Exhumación', 'segundaExhumacion', 80)}
                    <p>&nbsp;</p>
                    {createInput('Otros', 'segundaOtros', 80)}
                </div>
                <br></br>
                <div>
                    <strong>TERCERA. -</strong> La Inversión total de este Servicio funeral de uso inmediato que las partes aceptan expresamente es por la cantidad con IVA de $
                    {createInput('', 'terceraPesos', 150)}({createInput('', 'terceraPesosLetra', 500)})
                </div>
                <br></br>
                <div className="my-5">
                    <strong>CUARTA.-</strong> El CONSUMIDOR, Se obliga a pagar a partir de la firma del Presente contrato de la siguiente forma:<br></br>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>• Para los tramites oficiales y religiosos que se subcontrataran y se justificaran mediante &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;comprobante de pago.
                    &nbsp;&nbsp;{createInput('$', 'cuartaPago', 400)}
                    <br></br>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>• Anticipo del Servicio Funeral contratado en la clausula Primera del contrato $
                    {createInput('', 'cuartaAnticipo', 400, 'ml-6')}
                    <br></br>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>• Saldo del Paquete de Servicio funeral contratado para liquidarse en la fecha
                    {createInput('', 'cuartaFecha', 200)}
                    <br></br>
                    &nbsp;&nbsp;&nbsp;&nbsp;${createInput('', 'cuartaSaldo', 400)}
                </div>
                <div className="my-5">
                    <p>
                        Todos los Pagos descritos en el párrafo anterior deberán efectuarse en tiempo y forma convenidos sin necesidad de requerimiento judicial precisamente en el domicilio de PROVEEDOR, por lo que El CONSUMIDOR deberá proporcionar sus datos y presentar su cedula de RFC para la expedición de la factura definitiva en dos días hábiles después de efectuarse el pago total del importe convenido incisos (b) y (c) de esta cláusula, de conformidad con el artículo  de la Ley Federal de Protección al Consumidor.
                    </p>
                </div>
                <div className="my-5">
                    <strong>QUINTA.-</strong> Se establece que de no haber efectuado El Consumidor el pago en la fecha límite, causara
                    {createInput('', 'quintaInteres', 80)} % de interés moratorio mensual. Para tal efecto El Proveedor se reserva el derecho de aplicar las acciones que se deriven por incumplimiento del presente contrato.
                </div>
                <div className="my-5">
                    <p>
                        <strong>SEXTA.-</strong> En el supuesto de que El Proveedor ya se en caso fortuito o fuerza mayor se encuentre imposibilitado para prestar el servicio contratado, se obliga a hacer efectivo en lo derecho de os servicios funerarios a través de otra agencia Funeraria que se designe en el momento necesario, siendo los gastos por cuenta del Proveedor.
                    </p>
                </div>
                <div className="my-5">
                    <p>
                        <strong>SEPTIMA.-</strong> Las partes contratantes manifiestan que, para el caso de incumplimiento o cancelación de este contrato por parte del Consumidor, este se cubrirá como sanción a El Proveedor la suma correspondiente al valor de los servicios prestados al momento del incumplimiento o cancelación, Si el proveedor fuese el que incumpliere este se sujetará al Veredicto de la PROFECO.
                    </p>
                </div>
                <div className="my-5">
                    <p>
                        <strong>OCTAVA.-</strong> El presente contrato al aplicarse estará sujeto a las disposiciones contenidas por la Norma Oficial Mexicana NOM. -036SECOFI-2000 elementos informativos para la contratación de servicios funerarios y los artículos 57,58,77 y demás aplicables de la Ley Federal de Protección al Consumidor.
                    </p>
                </div>
                <div className="my-5">
                    <p>
                        <strong>NOVENA.-</strong> Para la interpretación, el cumplimiento o cualquier controversia que se pudieses sucitarse de este contrato, las partes se someten de antemano a la Jurisdicción y Competencia de los Tribunales de Ciudad Guzmán, Jalisco. Haciendo renuncia de cualquier otra que pudiere corresponderles por virtud de domicilio o futuro.
                    </p>
                </div>
                <div className="py-12">
                    <p>
                        <strong>DECIMA.-</strong> Después de haber leído el presente contrato, las partes hacen constar que el mismo no tiene clausulas contrarias a la moral o al derecho y manifiestan estar conformes y consistentes de los alcances legales de todas y cada una de las clausulas por lo que suscriben, libres de toda coacción el día de su fecha.
                    </p>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <div className="flex flex-row items-center justify-center w-full">
                    {createInput('', 'finFecha', 300)} del año {createInput('', 'finAnio', 150)}
                </div>
                <br></br>
                <br></br>
                <br></br>
                <div className="flex flex-row w-full mt-12">
                    <div className="w-1/2 my-16">
                        <div className="flex flex-col items-center justify-center mb-8">
                            <p className="">_________________________________________</p>
                            <p className="">EL CONSUMIDOR</p>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <div className="flex flex-row items-center justify-center w-full">
                                {createInput('', 'testigo1', 250)}
                            </div>
                            <p className="">TESTIGO</p>
                        </div>
                    </div>
                    <div className="w-1/2 my-16">
                        <div className="flex flex-col items-center justify-center mb-8">
                            <p className="">_________________________________________</p>
                            <p className="">EL PROVEEDOR</p>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <p className="">_________________________________________</p>
                            <p className="">TESTIGO</p>
                        </div>
                    </div>
                </div>
                <div className="p-4 border border-black">
                    <div className="w-full text-center">
                        <strong>PAGARE</strong>
                    </div>
                    <br></br>
                    <div>
                        Debo y pagare incondicionalmente a la orden de Ramon Aguilar Ureña en Ciudad Guzmán Jalisco o en otra Ciudad que se me requiera con fecha de vencimiento de
                        {createInput('', 'pagareVencimientoDia', 80)} de {createInput('', 'pagareVencimientoMes', 80)} del {createInput('', 'pagareVencimientoAnio', 80)}
                    </div>
                    <div>
                        La cantidad $ {createInput('', 'pagareCantidad', 200)} Valor de las mercancías recibidas a mi (nuestra) entera satisfacción
                        {createInput('', 'pagareSatisfaccion', 250)} Este pagare es mercantil y esta regido por la Ley General de Operaciones de Crédito en su artículo 173  parte final y demás artículos correlativos por no ser pagare domiciliado. De no liquidarse a la fecha de vencimiento, causara interés de
                        {createInput('', 'pagareCantidad2', 80)}% más los gastos que por ello se originen.
                        <br></br>
                        <br></br>
                        <br></br>
                        {createInput('Nombre', 'pagareNombre', 500)}
                        <br></br>
                        {createInput('Domicilio', 'pagareDomicilio', 500)}
                        <br></br>
                        {createInput('Ciudad', 'pagareCiudad', 500)}
                        <br></br>
                        {createInput('Teléfono', 'pagareTelefono', 500)}
                        <br></br>
                        <br></br>
                        <br></br>
                        {separador(8).map(item => item)}
                        <div className="w-full text-right">
                            <strong>ACEPTO</strong>{createInput('', 'pagareAcepto', 300)}
                        </div>
                        {separador(24).map(item => item)}
                        <div className="w-full text-center">
                            <strong>AVAL (ES)</strong>
                        </div>
                        <br></br>
                        {createInput('Nombre', 'avalNombre1', 500)}
                        <br></br>
                        {createInput('Domicilio', 'avalDomicilio1', 500)}
                        <br></br>
                        {createInput('Teléfono', 'avalTelefono1', 500)}
                        <br></br>
                        {createInput('Ciudad', 'avalCiudad1', 500)}
                        <br></br>
                        {separador(8).map(item => item)}
                        <br></br>
                        {createInput('Nombre', 'avalNombre2', 500)}
                        <br></br>
                        {createInput('Domicilio', 'avalDomicilio2', 500)}
                        <br></br>
                        {createInput('Teléfono', 'avalTelefono2', 500)}
                        <br></br>
                        {createInput('Ciudad', 'avalCiudad2', 500)}
                        <br></br>
                    </div>
                </div>
            </div>
            <div className="flex flex-row items-center justify-center w-full gap-20 pb-9">
                <button className="h-8 text-white duration-150 bg-blue-500 rounded-md cursor-pointer w-36 hover:bg-blue-900" onClick={handleSubmit}>{getDescriptionAccept()}</button>
                <ReactToPrint
                    trigger={() => <button className="h-8 text-white duration-150 bg-blue-500 rounded-md cursor-pointer w-36 hover:bg-blue-900">Generar PDF</button>}
                    content={() => divRef.current}
                    pageStyle="@page { size: 8.5in 14in; margin-bottom: 0.5in; } @media print { html, body { width: 8.5in; height: 14in; } }"
                />
            </div>

        </div>
    )
}

export default Contract